<template>
  <div>
    <van-nav-bar
      fixed
      title="采购入库"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- ---------------- -->
    <div id="aaa"></div>
      
    <van-cell title="影像中心" is-link center to="pwalist" size="large" label="江西省分宜县影像中心"/>
    <van-cell title="采购订单" is-link center to="orderlist" size="large" label="100000001-乐凯医疗科技有限公司"/>
    <!-- ---------------------- -->
    <van-cell title="备注" size="large"/>
    <van-field
      v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="50"
        placeholder="请输入备注信息"
        show-word-limit
    />
    <!-- ---------------- -->
    <van-cell title="入库仓库" is-link to="Warehouse" size="large" center label="CT室"/>
    <van-cell title="入库明细" size="large"/>
    <div class="box">
      <div class="box-c">
        <div class="box-d">
          <p class="a-p">胶片数据</p>
          <div class="b-p">
            <p>
              <span class="a-span">采购入库:100</span>
              <span class="a-span">已入数量:80</span>
            </p>
            <p>
              <span class="a-span">入库数量:
                <input type="text" class="ipt">
              </span>
              <span class="b-span">{{cccgsl1}}</span>
            </p>
          </div>
          <van-cell title="入库仓库" is-link to="Warehouse" size="large" center label="CT室"/>
             
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import { NavBar  , Tag , DropdownMenu, DropdownItem ,Col, Row } from 'vant';
export default {
  name:"paw",
  components:{
    [NavBar.name]:NavBar,
    [Tag.name]:Tag,
    [DropdownMenu.name]:DropdownMenu,
    [DropdownItem.name]:DropdownItem,
    [Col.name]:Col,
    [Row.name]:Row
  },
  data(){
    return{
      sty:"",
      activeNames: ['1','2'],
      message:'',
      radio: '1',
      lef: {
       
      },
      cccgsl1:"",
      cccgsl2:"超出采购数量",
      value1: 0,
      value2: 'a',
      option1: [
        { text: 'CT科室', value: 0 },
        { text: 'MR科室', value: 1 },
      ],
    }
  },
  
   methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    
  }
}
</script>
<style scoped lang="less">
#aaa{
  width:100vw;
  height:46px;
}
.van-nav-bar{
  background: #456;
  color:white;
}
.van-nav-bar__title{
  font-weight: 800;
  color:white
}
.van-nav-bar .van-icon{
  color:white
}
.box{
  width:100vw;
  height:26vh;
  padding:10px;
  box-sizing: border-box;
  // background:#eee;
  .box-c{
    width:94vw;
    height:24vh;
    background:#eee;
    box-sizing: border-box;
   
  };
  .box-d{
    width:92vw;
    .van-cell {
      line-height: 0.4rem;
      background:#eee
    }
  };
  .box-c .a-p{
      background:#eee;
      border-bottom: 2px solid #bbb;
      font-size: 0.4rem;
      // font-weight: bold;
      line-height: 0.8rem;
      padding: 0 5vw;
      box-sizing: border-box;
  };
  .box-c .b-p{
      background:#eee;
      font-size: 0.4rem;
      line-height: 0.1rem;
      padding: 0 5vw;
      box-sizing: border-box;
      .a-span{
        display:inline-block;
        width:40vw;
      };
      .ipt{
        width:15vw;
        height:2vh;
        background:#fff;
      };
      .b-span{
        display:inline-block;
        width:40vw;
        color:red;
        font-size: 0.35rem;      
      }
  } 
}

.van-col-8{
    font-size: 16px;
    margin-left: 16px;
    padding:16px;
}
.van-dropdown-menu {
  background:#eee;
}
.van-dropdown{
  background:#fff;

}
</style>